import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import React from 'react';
import styles from './index.module.scss';
import TextAniA from './TextAniA';
import getLocal from '@/app/utils/getLocal';

const SectionB1: React.FC<{ pageType: string }> = ({ pageType = 'normal' }) => {
    const { t } = useLang('theProduct.SectionB1');
    const desc = pageType === 'ultra' ? t('ultra_desc') : pageType === 'ac' ? t('ac_desc') : t('desc');

    const { locale } = getLocal();
    const title = locale === 'de' ? t('ultra_title') : t('title');

    const isNA = ['us', 'ca'].includes(locale);

    const imgObj = isNA
        ? {
              pc: 'https://websiteoss.ecoflow.com/upload/image/1745996060530/kwh-pc.jpg',
              pad: 'https://websiteoss.ecoflow.com/upload/image/1745996940439/kwh-h5.png',
              h5: 'https://websiteoss.ecoflow.com/upload/image/1745996940439/kwh-h5.png',
          }
        : {
              pc: 'https://websiteoss.ecoflow.com/upload/image/1745837472683/pc.jpg',
              pad: 'https://websiteoss.ecoflow.com/upload/image/1745837472683/pc.jpg',
              h5: 'https://websiteoss.ecoflow.com/upload/image/1745837472524/h5.jpg',
          };

    return (
        <>
            <section className={`${styles.SectionB1} GtmModuleData-section`} data-section-id="SectionB1" data-section-title={t('title')}>
                <EcoSectionCommon label={t('label')} title={title} desc={desc} />
                <TextAniA pageType={pageType} />
                <div className="SectionB1-text2">{pageType === 'ac' ? t('text2_ac') : t('text2')}</div>
                <div className="SectionB1-img-out">
                    <EcoImg pc={imgObj.pc} pad={imgObj.pad} h5={imgObj.h5} className="SectionB1-img" isOpenLazy />
                </div>
                {isNA && <div className="footer_desc eco-content">{t('footer_desc')}</div>}
            </section>
        </>
    );
};

export default SectionB1;
